import React from 'react';
import Helmet from 'react-helmet';
import { Container, Stack, useMediaQuery, useTheme } from '@mui/material';
import { matchPath, Route, Routes, useLocation } from 'react-router-dom';
import { Breadcrumbs, BurgerMenu, Header } from '../../components';
import { ImportDetail } from './ImportDetail';
import { ImportWorkflow } from './ImportWorkflow';
import { ImportsList } from './ImportsList';
import { ImportsMenu } from './ImportsMenu';
import { useIntl } from 'react-intl';

const pageStyles = { width: '100%', height: '100%' };

export const Imports = React.memo(() => {
  const intl = useIntl();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isWorkflow = Boolean(
    matchPath('/imports/create', location.pathname) ||
      matchPath('/imports/standard/:importId/workflow', location.pathname) ||
      matchPath('/imports/:importId/workflow', location.pathname)
  );

  if (isWorkflow) {
    return (
      <Routes>
        <Route path="create" element={<ImportWorkflow />} />
        <Route
          path="standard/:importId/workflow"
          element={<ImportWorkflow />}
        />
        <Route path=":importId/workflow" element={<ImportWorkflow />} />
      </Routes>
    );
  }

  return (
    <div style={pageStyles}>
      <Helmet
        title={intl.formatMessage({
          id: 'imports.pageTitle',
          defaultMessage: 'Imports | Acolyte',
        })}
      />
      <Header mainIcon={isMobile && <BurgerMenu menu={<ImportsMenu />} />} />
      <Container maxWidth="xl">
        <Stack direction="row">
          {!isMobile && <ImportsMenu />}
          <Stack flexGrow={1} gap={1} minWidth={0}>
            <Breadcrumbs />
            <Routes>
              <Route index element={<ImportsList />} />
              <Route path=":importId" element={<ImportDetail />} />
            </Routes>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
});
